// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"a952acfe","361":"3d864bc7"}[chunkId] + ".chunk.css";
};